import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import * as Toast from '../../lib/Toast.js';
import { formatCurrency } from '../../lib/CurrencyHelpers.js';
import { useState } from 'react';
import Select from '../Select';
import TextArea from '../TextArea.jsx';
import { setPaymentHistory } from '../../lib/Queries';
import Toggle from '../Toggle.jsx';
import ManualEntryForm, {
    ManualEntryMethodOptions,
} from './ManualEntryForm.jsx';
import TextInput from "~/components/TextInput";

const PaymentWithManualEntry = ({
                                    objectId,
                                    objectType,
                                    amount,
                                    onSave,
                                    totalPrice,
                                    totalPaid,
                                }) => {
    const [code, setCode] = useState('')

    const { save, isSaving } = useBusinessPostApi(
        `/payments/gift-certificate/${objectType}/${objectId}`,
    );


    function doSave() {
        save({
            amount,
            code
        }).then(result => {
            Toast.success(
                `Successfully made a ${formatCurrency(amount)} gift certificate payment`,
            );
            setPaymentHistory(objectType, objectId, result);
            onSave();
        });
    }

    return (
        <div>
            <TextInput
                label="Gift Certificate Code"
                onChange={setCode}
                value={code}
                required={true}
                className="mb-4"
            />

            <button type="button" className="btn-save" onClick={doSave}>
                {isSaving ? 'Saving...' : 'Save'}
            </button>
        </div>
    );
};

export default PaymentWithManualEntry;
